// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"1ab167d9","394":"0e58a8bc","474":"d205e3de","499":"94291144","668":"4a83b98e","729":"adf3d40a"}[chunkId] + ".js";
};